export default __webpack_public_path__ + "static/media/log.3545abd6.png";